import React from "react";

export const CurrencyFlag: React.FC<{ currency: string }> = ({ currency }) => {
  const curr = (currency || "").toUpperCase();

  if (curr === "NGN") {
    return (
      <span
        aria-label="NGN"
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E4E7EC] shadow-xs"
      >
        <svg viewBox="0 0 20 20" className="h-full w-full" fill="none">
          <circle cx="10" cy="10" r="10" fill="#FFFFFF" />
          <rect x="0" y="0" width="6.67" height="20" fill="#008751" />
          <rect x="13.33" y="0" width="6.67" height="20" fill="#008751" />
        </svg>
      </span>
    );
  }

  if (curr === "USD") {
    return (
      <span
        aria-label="USD"
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E4E7EC] shadow-xs"
      >
        <svg viewBox="0 0 20 20" className="h-full w-full" fill="none">
          <circle cx="10" cy="10" r="10" fill="#FCFAFF" />
          <rect y="2" width="20" height="2.5" fill="#D80027" />
          <rect y="7" width="20" height="2.5" fill="#D80027" />
          <rect y="12" width="20" height="2.5" fill="#D80027" />
          <rect y="16.5" width="20" height="2.5" fill="#D80027" />
          <rect x="0" y="0" width="9.5" height="10" fill="#0052B4" />
          <circle cx="2.5" cy="2.5" r="0.8" fill="#FFFFFF" />
          <circle cx="6.5" cy="2.5" r="0.8" fill="#FFFFFF" />
          <circle cx="4.5" cy="5" r="0.8" fill="#FFFFFF" />
          <circle cx="2.5" cy="7.5" r="0.8" fill="#FFFFFF" />
          <circle cx="6.5" cy="7.5" r="0.8" fill="#FFFFFF" />
        </svg>
      </span>
    );
  }

  if (curr === "EUR") {
    return (
      <span
        aria-label="EUR"
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E4E7EC] shadow-xs bg-[#003399]"
      >
        <svg viewBox="0 0 20 20" className="h-full w-full">
          <circle cx="10" cy="10" r="10" fill="#003399" />
          <circle cx="10" cy="3.5" r="0.9" fill="#FFCC00" />
          <circle cx="10" cy="16.5" r="0.9" fill="#FFCC00" />
          <circle cx="3.5" cy="10" r="0.9" fill="#FFCC00" />
          <circle cx="16.5" cy="10" r="0.9" fill="#FFCC00" />
          <circle cx="5.4" cy="5.4" r="0.9" fill="#FFCC00" />
          <circle cx="14.6" cy="5.4" r="0.9" fill="#FFCC00" />
          <circle cx="5.4" cy="14.6" r="0.9" fill="#FFCC00" />
          <circle cx="14.6" cy="14.6" r="0.9" fill="#FFCC00" />
        </svg>
      </span>
    );
  }

  if (curr === "GBP") {
    return (
      <span
        aria-label="GBP"
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E4E7EC] shadow-xs bg-[#00247D]"
      >
        <svg viewBox="0 0 20 20" className="h-full w-full">
          <circle cx="10" cy="10" r="10" fill="#00247D" />
          <path d="M0 0L20 20M20 0L0 20" stroke="#FFFFFF" strokeWidth="3" />
          <path d="M0 0L20 20M20 0L0 20" stroke="#CF142B" strokeWidth="1.5" />
          <path d="M10 0V20M0 10H20" stroke="#FFFFFF" strokeWidth="4.5" />
          <path d="M10 0V20M0 10H20" stroke="#CF142B" strokeWidth="2.5" />
        </svg>
      </span>
    );
  }

  if (curr === "KES") {
    return (
      <span
        aria-label="KES"
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E4E7EC] shadow-xs"
      >
        <svg viewBox="0 0 20 20" className="h-full w-full">
          <circle cx="10" cy="10" r="10" fill="#FFFFFF" />
          <rect y="0" width="20" height="6" fill="#000000" />
          <rect y="6" width="20" height="8" fill="#BB0000" />
          <rect y="14" width="20" height="6" fill="#006600" />
          <line x1="0" y1="6" x2="20" y2="6" stroke="#FFFFFF" strokeWidth="0.8" />
          <line x1="0" y1="14" x2="20" y2="14" stroke="#FFFFFF" strokeWidth="0.8" />
        </svg>
      </span>
    );
  }

  return (
    <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#E4E7EC] bg-[#EEF1FB] text-[9px] font-bold text-[#344054]">
      {curr.slice(0, 2) || "$"}
    </span>
  );
};
